'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _nonMerchandiseIdProductPropInterface = require('pricing-pages-unified-ui/utils/nonMerchandiseIdProductPropInterface');

var _nonMerchandiseIdProductPropInterface2 = _interopRequireDefault(_nonMerchandiseIdProductPropInterface);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DTB_BASE_URL = 'https://app.hubspot.com/signup/purchase?intent=purchase';

var trackClick = function trackClick(_ref) {
  var sourceId = _ref.sourceId,
      merchandiseId = _ref.merchandiseId,
      nonMerchandiseIdProduct = _ref.nonMerchandiseIdProduct,
      hubsSignupUrl = _ref.hubsSignupUrl,
      hubsSignupCta = _ref.hubsSignupCta,
      bundledOffer = _ref.bundledOffer;

  (0, _getUsageTracker2.default)().track('buyClick', {
    sourceId: sourceId,
    merchandiseId: merchandiseId,
    nonMerchandiseIdProduct: nonMerchandiseIdProduct,
    hubsSignupUrl: hubsSignupUrl,
    hubsSignupCta: hubsSignupCta,
    bundledOffer: bundledOffer
  });
};

var DTBButton = function DTBButton(_ref2) {
  var sourceId = _ref2.sourceId,
      currencyCode = _ref2.currencyCode,
      merchandiseId = _ref2.merchandiseId,
      dtbSource = _ref2.dtbSource,
      bundledOffer = _ref2.bundledOffer,
      use = _ref2.use,
      className = _ref2.className,
      nonMerchandiseIdProduct = _ref2.nonMerchandiseIdProduct;

  var hubsSignupCta = (0, _publicPageUrls.getHubsSignupCTA)('buy', sourceId, merchandiseId, nonMerchandiseIdProduct);
  var gaClassName = (0, _publicPageUrls.getGAClassName)(hubsSignupCta);
  var hubsSignupUrl = (0, _publicPageUrls.getHubsSignupUrl)({
    merchandiseId: merchandiseId,
    nonMerchandiseIdProduct: nonMerchandiseIdProduct
  });

  var HREF = DTB_BASE_URL + '&currency=' + [currencyCode] + '&hubs_signup-url=' + hubsSignupUrl + '&hubs_signup-cta=' + hubsSignupCta + '&bundledOffer=' + bundledOffer + '&dtb_source=' + dtbSource;

  return _react2.default.createElement(
    _UIButton2.default,
    {
      use: use,
      href: HREF,
      className: gaClassName + ' ' + className,
      onClick: (0, _partial2.default)(trackClick, {
        sourceId: sourceId,
        merchandiseId: merchandiseId,
        nonMerchandiseIdProduct: nonMerchandiseIdProduct,
        hubsSignupUrl: hubsSignupUrl,
        hubsSignupCta: hubsSignupCta,
        bundledOffer: bundledOffer
      })
    },
    _react2.default.createElement(_FormattedMessage2.default, {
      message: 'pricingPage.pricingCtas.buyNow',
      className: gaClassName
    })
  );
};

DTBButton.propTypes = _extends({
  sourceId: _react.PropTypes.string.isRequired,
  currencyCode: _react.PropTypes.string.isRequired,
  bundledOffer: _react.PropTypes.string.isRequired,
  merchandiseId: _react.PropTypes.number,
  use: _react.PropTypes.string.isRequired,
  className: _react.PropTypes.string
}, _nonMerchandiseIdProductPropInterface2.default);

DTBButton.defaultProps = {
  use: 'primary'
};

exports.default = DTBButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/public-only/DTBButton.js
// module id = 714
// module chunks = 3 4